import React from 'react';
import { useSelector } from 'react-redux';

// utils
import { fieldExistsInConfig } from '../../../../utils/form';

import './styles.scss';

function FormRow({
  children,
  className,
  id,
  style,
  hide = false,
  indent,
  showIfFieldsExist = [],
  showIfFieldExists = '',
}) {
  const { form: { form } } = useSelector(store => store);
  const indentStyles = indent ? {
    borderLeft: 'solid 3px var(--bs-gray-400)',
    paddingLeft: '1.5em',
    marginLeft: '1em',
  } : {};

  let show = !hide;
  if (showIfFieldsExist.length) {
    show = false;
    showIfFieldsExist.forEach(field => {
      if (fieldExistsInConfig(form, field)) {
        show = true;
      }
    });
  } else if (showIfFieldExists) {
    show = fieldExistsInConfig(form, showIfFieldExists);
  }

  return show ? (
    <div
      className={['input-row row ps-1', className].join(' ')}
      id={id}
      style={{ ...indentStyles, ...style }}
    >
      {children}
    </div>
  ) : null;
}

export default FormRow;
